import React from 'react'
import { Toggle, Divider, ToggleGroup } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@fs/zion-analytics'
import { useDarkModeContext } from '../../providers/darkModeProvider/DarkModeProvider'

export default function DarkModeControl() {
  const [t] = useTranslation()
  const { isDarkModeOn, setIsDarkModeOn } = useDarkModeContext()

  const handleChange = ({ target: { checked } }) => {
    setIsDarkModeOn(checked)

    // Track the toggle event for analytics, including the new value of the toggle (checked or unchecked)
    trackEvent({
      event_name: 'click_action',
      link_name: 'dark_mode_toggle',
      link_value: checked,
    })
  }

  return (
    <>
      <Divider label={t('film-viewer.toggle-dark-mode.label', 'Toggle Dark Mode')} marginY="xxs" />
      <ToggleGroup>
        <Toggle
          label={t('shared-image-viewer.darkMode', 'Dark Mode')}
          allowLabelWrapping
          name="darkMode"
          checked={isDarkModeOn}
          onChange={handleChange}
          data-testid="dark-mode-toggle"
        />
      </ToggleGroup>
    </>
  )
}
